<template>
    <transition
        appear
        :css="false"
        @enter="zoomIn"
    >
        <div class="text-box" :class="[leftBorderOnly ? 'left-border-only' : '']">
            <div
                ref="border"
                :class="[
                    background ? `${background}-background` : '',
                    speechTail ? `${speechTail}-speech-tail` : '',
                ]"
                class="border"
            />
            <div ref="content" class="content">
                <slot />
            </div>
        </div>
    </transition>
</template>

<script>
import gsap from 'gsap';

export default {
    name: 'TextBox',
    props: {
        background: {
            type: String,
            default: ''
        },
        speechTail: {
            type: String,
            default: ''
        },
        leftBorderOnly: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        zoomIn(el, done)
        {
            // wenn v-show verwendet wird, setzen wir visibility auf hidden, damit Element trotzdem
            // den Platz einnimmt
            const {style} = el;
            if (style.display === 'none')
            {
                done();
                style.visibility = 'hidden';
                style.display = '';
                return;
            }
            if (style.visibility === 'hidden')
            {
                style.visibility = '';
            }

            const {$refs} = this;
            gsap.timeline({onComplete: done})
                .fromTo(
                    $refs.border,
                    {scale: 0.5, opacity: 0},
                    {duration: 1, scale: 1, opacity: 1, ease: 'elastic.out(1.1, 1)', force3D: false}
                )
                .fromTo(
                    $refs.content,
                    {scale: 0.5, opacity: 0},
                    {duration: 1.2, scale: 1, opacity: 1, ease: 'elastic.out(1.1, 0.9)'},
                    0.1
                )
                .set([$refs.border, $refs.content], {clearProps: 'all'});
        }
    }
};
</script>

<style lang="scss" src="./TextBox.scss" />

